// router.tsx
import { createBrowserRouter } from "react-router-dom";
import { Layout } from "../Layout";

import { Home, About, WigglyPaint, Poetry } from "../components/pages";

import { AnimatedGifs } from "../components/pages/AnimatedGifs";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "about", element: <About /> },
      { path: "wiggly-paint", element: <WigglyPaint /> },
      { path: "poetry", element: <Poetry /> },
      { path: "animated-gifs", element: <AnimatedGifs /> },
    ],
  },
]);
